import { render, staticRenderFns } from "./modal-edit-page.vue?vue&type=template&id=5fdade36&scoped=true"
import script from "./modal-edit-page.vue?vue&type=script&lang=js"
export * from "./modal-edit-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdade36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdade36')) {
      api.createRecord('5fdade36', component.options)
    } else {
      api.reload('5fdade36', component.options)
    }
    module.hot.accept("./modal-edit-page.vue?vue&type=template&id=5fdade36&scoped=true", function () {
      api.rerender('5fdade36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/view/components/setting-page/components/modal-edit-page.vue"
export default component.exports